import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  backgroundColor01,
  bgGradientColor,
  blackColor,
  blackColor27,
  dashboardDescriptionColor,
  emptyMessageColor,
  greyColor9,
  whiteColor,
} from '../configs/styles/muiThemes'
import { Link, useNavigate } from 'react-router-dom'
import { navigateTo } from 'utils/urlHelper'

export default function EmptyCard({
  message,
  messageSize,
  description,
  imageUrl,
  actionBtnText,
  type,
  onTypeClick,
  iconWidth,
  bgcolor,
  iconHeignt,
  imgpadding,
  cardbottom,
  imageboxpadding,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up('md'))
  const navigate = useNavigate()

  const businessName = sessionStorage.getItem("businessName");
  let businessFullName = sessionStorage.getItem("businessFullName");

  return matches ? (
    <Container sx={styles.container} backgroundColor={whiteColor}>
      <Box
        backgroundColor={whiteColor}
        padding={imageboxpadding ? imageboxpadding : "35px"}
        borderRadius={"10px"}
      >
        <Box
          component="img"
          src={imageUrl}
          width={{
            xs: iconWidth ? iconWidth : "100px",
            md: iconWidth ? iconWidth : "100px",
          }}
          height="auto"
          alt={businessFullName + " CostBo"}
        />
        <Typography
          variant="h6"
          fontSize={{ xs: 12, md: messageSize ? messageSize : 15 }}
          color={emptyMessageColor}
          marginBottom={"8px"}
          lineHeight={{ xs: "20px", md: "26px" }}
        >
          {message}
        </Typography>

        {description ? (
          <Typography
            variant="body1"
            fontSize={{ xs: 11.5, md: 13 }}
            color={dashboardDescriptionColor}
            lineHeight={{ xs: "20px", md: "23px" }}
          >
            {description}
          </Typography>
        ) : null}

        {actionBtnText ? (
          <Button
            // component={Link}
            // to={`/${businessName}/catalog`}
            onClick={()=>{
              navigateTo(navigate, `catalog`)
            }}
            variant="contained"
            disableElevation
            sx={styles.actionBtnMobile}
          >
            {actionBtnText}
          </Button>
        ) : null}

        {type ? (
          <Button
            variant="contained"
            disableElevation
            onClick={onTypeClick}
            sx={styles.actionBtnMobile}
          >
            {type}
          </Button>
        ) : null}
      </Box>
    </Container>
  ) : (
    <Box
      width={{ xs: "auto", md: "100%" }}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      backgroundColor={bgcolor ? bgcolor : whiteColor}
      padding={{ md: 2, xs: "20px" }}
      borderRadius={"10px"}
      border={"1px solid #E1E1EE"}
      mb={cardbottom ? cardbottom : 5}
      mt={1}
    >
      {/* <Box sx={{ padding: '20px' }}> */}
      <Box
        component="img"
        src={imageUrl}
        width={{ xs: iconWidth ? iconWidth : "44px", md: "100px" }}
        height={{ xs: iconHeignt ? iconHeignt : "auto", md: "100px" }}
        alt={businessFullName + " CostBo"}
        sx={{ padding: imgpadding ? imgpadding : "none" }}
      />
      {/* </Box> */}

      <Typography
        sx={{
          fontSize: { md: 15, xs: 14 },
          fontWeight: 600,
          textAlign: "center",
          color: blackColor27,
          lineHeight: "21px",
          mt: { md: -0.2, xs: "8px" },
        }}
      >
        {message}
      </Typography>
      {description ? (
        <Typography
          variant="body1"
          fontSize={{ xs: 12, md: 10.5 }}
          color={{ md: greyColor9, xs: greyColor9 }}
          lineHeight={{ xs: "20px", md: "23px" }}
          mt={"2px"}
          textAlign={"center"}
        >
          {description}
        </Typography>
      ) : null}

      {actionBtnText ? (
        <Button
          // component={Link}
          // to={`/${businessName}/catalog`}
          onClick={()=>{
            navigateTo(navigate, `catalog`)
          }}
          variant="contained"
          disableElevation
          sx={styles.actionBtnMobile}
        >
          {actionBtnText}
        </Button>
      ) : null}

      {type ? (
        <Button
          variant="contained"
          disableElevation
          onClick={onTypeClick}
          sx={styles.actionBtnMobile}
        >
          {type}
        </Button>
      ) : null}
    </Box>
  );
}

const styles = {
  container: {
    maxWidth: { xs: "auto", md: "1370px !important" },
    px: { xs: "30px", md: "0px" },
    // py: "15px",
    textAlign: "center",
    borderRadius: "10px !important",
  },
  actionBtn: {
    mt: 3,
    "&:hover": {
      color: whiteColor,
    },
  },
  actionBtnMobile: {
    background: bgGradientColor,
    color: "#fff",
    border: "1px solid #000",
    padding: "7px 30px",
    borderRadius: "50px",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.2px",
    marginTop: "12px",
    mb: 2,
    fontWeight: "600",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: whiteColor,
      color: blackColor,
    },
  },
};
